import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaymentService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;

    private viewPayment =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.viewPayments;

    private requestPayment =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.requestPayments;

    private getAccesorii =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.getAccesorii;

    public downloadPaymentsCsvUrl =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.downloadPaymentsCSV;

    private resetInvoiceStatusUrl =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.resetInvoiceStatus;

    private deletePaymentDuplicateUrl =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.deletePaymentDuplicate;

    private approvePaymentUrl =
        this.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.approvePayment;

    constructor(private http: HttpClient) { }

    viewPayments(id: number) {
        return this.http.get(this.viewPayment + id, this.httpOptions);
    }

    requestPayments(id: number) {
        return this.http.get(this.requestPayment + id, this.httpOptions);
    }

    getAccessories(id: number): Observable<any[]> {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getAccesorii + id
            )
            .pipe(map((response) => response.data));
    }

    resetInvoiceStatus(id: number) {
        return this.http.get(this.resetInvoiceStatusUrl + id, this.httpOptions);
    }

    deletePaymentDuplicate(id: number) {
        return this.http.get(this.deletePaymentDuplicateUrl + id, this.httpOptions);
    }

    approvePayment(id: number) {
        return this.http.get(this.approvePaymentUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
